import { apiClient } from './client';
import type { UsuarioSistema, RolUsuario } from '@/types/dominio';

export interface ListUsuariosParams {
  busqueda?: string;
  rol?: RolUsuario;
}

export interface CrearUsuarioPayload {
  username: string;
  email?: string;
  password: string;
  rol: RolUsuario;
}

export interface ActualizarUsuarioPayload {
  email?: string;
  password?: string;
  rol?: RolUsuario;
  activo?: boolean;
}

export async function getUsuarios(params: ListUsuariosParams = {}): Promise<UsuarioSistema[]> {
  const { data } = await apiClient.get<UsuarioSistema[]>('/usuarios', { params });
  return data;
}

export async function crearUsuario(payload: CrearUsuarioPayload): Promise<UsuarioSistema> {
  const { data } = await apiClient.post<UsuarioSistema>('/usuarios', payload);
  return data;
}

export async function actualizarUsuario(
  id: string,
  payload: ActualizarUsuarioPayload,
): Promise<UsuarioSistema> {
  const { data } = await apiClient.patch<UsuarioSistema>(`/usuarios/${id}`, payload);
  return data;
}
